import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-light dark:bg-dark px-4">
      <div className="text-center">
        <h1 className="text-9xl font-bold text-primary mb-4">404</h1>
        <h2 className="text-3xl font-bold text-dark dark:text-light mb-2">Sayfa Bulunamadı</h2>
        <p className="text-gray-600 dark:text-gray-400 mb-8">
          Aradığınız sayfa maalesef bulunamadı veya silinmiş olabilir.
        </p>

        <button
          onClick={() => navigate(-1)}
          className="inline-flex items-center gap-2 bg-primary text-white px-6 py-3 rounded-lg hover:bg-secondary transition-smooth"
        >
          <ArrowLeft size={20} />
          Geri Dön
        </button>
      </div>
    </div>
  );
};
